// Who is logged in, as stored at login. The server enforces the same rules
// (super_server_2.0/internal/cms/access.go); this only decides what the UI shows.

export const TETRA_GROUP_ID = "1";

export const currentGroupId = () => localStorage.getItem("group_id") || localStorage.getItem("groupId") || "";

// Tetra (group 1) sees every group's data and can add or change things.
// Every other group sees only its own stations and is view-only.
export const isTetra = () => currentGroupId() === TETRA_GROUP_ID;

export const getAuthToken = () => localStorage.getItem("authToken") || localStorage.getItem("auth_token") || "";

export const setAuthToken = (token) => {
  localStorage.setItem("authToken", token);
  localStorage.setItem("auth_token", token);
};
